<!-- GSAP custom cursor (tracked by rs-anim-int.js gsap_rs_custom_cursor) -->
<div id="rs-mouse">
  <div id="cursor-ball"></div>
</div>

<div class="mobile-menu-wrapper"></div>
<app-preloader></app-preloader>
<router-outlet></router-outlet>
<app-footer></app-footer>
<div id="backtotop-wrap" class="rs-backtotop has-theme-red" style="display:none;">
  <svg class="arrowicon" viewBox="0 0 24 24" width="18" height="18">
    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#000"></path>
  </svg>
  <svg class="scrollprogress" width="40" height="40">
    <circle class="progress-circle" cx="20" cy="20" r="18" stroke-width="2" fill="none" stroke="#fff" stroke-dasharray="113.1" stroke-dashoffset="113.1"></circle>
  </svg>
</div>
